<template>
  <b-modal
    ref="modal"
    :title="title"
    size="md"
    ok-title="Vista fyrir alla"
    cancel-title="Hætta við"
    @ok="submit"
    :ok-disabled="submitting || hoursInvalid"
  >
    <b-form-group label="Fj. tíma" label-for="bulk-hours">
      <b-form-input id="bulk-hours" v-model="form.hours" type="text" :state="hoursInvalid ? false : null" autofocus></b-form-input>
      <b-form-invalid-feedback v-if="hoursInvalid"> Hámarks fjöldi tíma á þessum degi er: {{ maxHours }}. </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Verkefni" label-for="bulk-project" v-if="projectList.length > 0">
      <b-form-select id="bulk-project" v-model="form.projectId">
        <option :value="null">-- Veldu verkefni --</option>
        <option v-for="p in projectList" :key="p.id" :value="p.id">{{ p.name }}</option>
      </b-form-select>
    </b-form-group>

    <div v-if="submitting" class="text-center mt-2">
      <b-spinner small></b-spinner>
      <span class="ml-2">Vista...</span>
    </div>
  </b-modal>
</template>

<script>
import { normalizeHoursInput } from '@/utils';

export default {
  name: 'bulk-attendance-modal',
  props: {
    projectList: { type: Array, default: () => [] },
  },
  data() {
    return {
      title: '',
      maxHours: null,
      submitting: false,
      form: {
        hours: '',
        projectId: null,
      },
    };
  },
  computed: {
    hoursInvalid() {
      if (this.maxHours === null || this.form.hours === '') return false;
      const parsed = parseFloat(normalizeHoursInput(this.form.hours));
      return !Number.isFinite(parsed) || parsed > this.maxHours;
    },
  },
  methods: {
    show({ title, maxHours }) {
      this.title = title || 'Setja fyrir alla';
      this.maxHours = maxHours ?? null;
      this.form = { hours: '', projectId: null };
      this.submitting = false;
      this.$refs.modal.show();
    },
    submit() {
      this.$emit('save', {
        hours: this.form.hours,
        projectId: this.form.projectId,
      });
    },
  },
};
</script>
